import { render, staticRenderFns } from "./AddOrdersToCurrentInvoice.vue?vue&type=template&id=3fa03910&"
import script from "./AddOrdersToCurrentInvoice.vue?vue&type=script&lang=js&"
export * from "./AddOrdersToCurrentInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports